import { createContext, useState } from "react";
import { jsonConfig } from '../Config';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [signed, setSigned] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')

    const [modalMsg, setModalMsg] = useState(false)
    const [msgModalMsg, setMsgModalMsg] = useState('')
    const [descModalMsg, setDescModalMsg] = useState('')
    const [titleButtonModalMsg, setTitleButtonModalMsg] = useState('Retornar')
    const [titleButtonCloseModalMsg, setTitleButtonCloseModalMsg] = useState('Fechar')
    const [perigoModalMsg, setPerigoModalMsg] = useState(false)
    const [functionModalMsg, setFunctionModalMsg] = useState(() => { })

    const [sideBar, setSideBar] = useState(false)


    const [dataEstatisticaRecuperacaoSenha, setDataEstatisticaRecuperacaoSenha] = useState([])
    const [dataRecuperacaoSenha, setDataRecuperacaoSenha] = useState([])
    const [RecuperacaoSenha, setRecuperacaoSenha] = useState({})
    const [offsetRecuperacaoSenha, setOffsetRecuperacaoSenha] = useState(0)
    const [limiteRecuperacaoSenha, setLimiteRecuperacaoSenha] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRecuperacaoSenha, setLimiteBuscaRecuperacaoSenha] = useState(false)

    const [dataEstatisticaUsuarios, setDataEstatisticaUsuarios] = useState([])
    const [dataUsuarios, setDataUsuarios] = useState([])
    const [Usuarios, setUsuarios] = useState({})
    const [offsetUsuarios, setOffsetUsuarios] = useState(0)
    const [limiteUsuarios, setLimiteUsuarios] = useState(jsonConfig.limitDefault)
    const [limiteBuscaUsuarios, setLimiteBuscaUsuarios] = useState(false)
    const [modalUsuarios, setModalUsuarios] = useState(false)

    const [dataEstatisticaLogs, setDataEstatisticaLogs] = useState([])
    const [dataLogs, setDataLogs] = useState([])
    const [Logs, setLogs] = useState({})
    const [offsetLogs, setOffsetLogs] = useState(0)
    const [limiteLogs, setLimiteLogs] = useState(jsonConfig.limitDefault)
    const [limiteBuscaLogs, setLimiteBuscaLogs] = useState(false)
    const [modalLogs, setModalLogs] = useState(false)


    //Page, per_page, sort, sort_dir, filter
    const [page, setPage] = useState(0)
    const [per_page, setPer_page] = useState(jsonConfig.limitDefault)
    const [sort, setSort] = useState("data_criacao")
    const [sort_dir, setSort_dir] = useState("desc")
    const [filter, setFilter] = useState(null)

    const [dataEstatisticaRequests, setDataEstatisticaRequests] = useState([])
    const [dataRequests, setDataRequests] = useState([])
    const [Requests, setRequests] = useState({})
    const [offsetRequests, setOffsetRequests] = useState(0)
    const [limiteRequests, setLimiteRequests] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRequests, setLimiteBuscaRequests] = useState(false)
    const [modalRequests, setModalRequests] = useState(false)


    const [dataContasRecebimento, setDataContasRecebimento] = useState([])
    const [ContasRecebimento, setContasRecebimento] = useState({})
    const [modalContasRecebimento, setModalContasRecebimento] = useState(false)
    const [isEditContasRecebimento, setIsEditContasRecebimento] = useState(false)

    const [dataServicos, setDataServicos] = useState([])
    const [Servico, setServico] = useState({})
    const [modalServico, setModalServico] = useState(false)

    const [dataClientes, setDataClientes] = useState([])
    const [Cliente, setCliente] = useState({})
    const [modalCliente, setModalCliente] = useState(false)

    const [dataFaturas, setDataFaturas] = useState([])
    const [Fatura, setFatura] = useState({})
    const [modalFatura, setModalFatura] = useState(false)


    const states = {
        // Paginação e filtros
        page,
        per_page,
        sort,
        sort_dir,
        filter,
        // Requests
        dataEstatisticaRequests,
        dataRequests,
        Requests,
        offsetRequests,
        limiteRequests,
        limiteBuscaRequests,
        modalRequests,
        // Logs
        dataEstatisticaLogs,
        dataLogs,
        Logs,
        offsetLogs,
        limiteLogs,
        limiteBuscaLogs,
        modalLogs,
        // Usuários
        dataEstatisticaUsuarios,
        dataUsuarios,
        Usuarios,
        offsetUsuarios,
        limiteUsuarios,
        limiteBuscaUsuarios,
        modalUsuarios,
        // Recuperação de Senha
        dataEstatisticaRecuperacaoSenha,
        dataRecuperacaoSenha,
        RecuperacaoSenha,
        offsetRecuperacaoSenha,
        limiteRecuperacaoSenha,
        limiteBuscaRecuperacaoSenha,
        // Estados gerais
        signed,
        isLoading,
        email,
        senha,
        modalMsg,
        msgModalMsg,
        descModalMsg,
        perigoModalMsg,
        titleButtonModalMsg,
        functionModalMsg,
        titleButtonCloseModalMsg,
        sideBar,
        isEdit,
        // Contas Recebimento
        dataContasRecebimento,
        ContasRecebimento,
        modalContasRecebimento,
        isEditContasRecebimento,
        // Serviços
        dataServicos,
        Servico,
        modalServico,
        // Clientes
        dataClientes,
        Cliente,
        modalCliente,
        // Faturas
        dataFaturas,
        Fatura,
        modalFatura,
    }

    const setters = {
        // Paginação e filtros
        setPage,
        setPer_page,
        setSort,
        setSort_dir,
        setFilter,
        // Requests
        setDataEstatisticaRequests,
        setDataRequests,
        setRequests,
        setOffsetRequests,
        setLimiteRequests,
        setLimiteBuscaRequests,
        setModalRequests,
        // Logs
        setDataEstatisticaLogs,
        setDataLogs,
        setLogs,
        setOffsetLogs,
        setLimiteLogs,
        setLimiteBuscaLogs,
        setModalLogs,
        // Usuários
        setDataEstatisticaUsuarios,
        setDataUsuarios,
        setUsuarios,
        setOffsetUsuarios,
        setLimiteUsuarios,
        setLimiteBuscaUsuarios,
        setModalUsuarios,
        // Recuperação de Senha
        setDataEstatisticaRecuperacaoSenha,
        setDataRecuperacaoSenha,
        setRecuperacaoSenha,
        setOffsetRecuperacaoSenha,
        setLimiteRecuperacaoSenha,
        setLimiteBuscaRecuperacaoSenha,
        // Estados gerais
        setSigned,
        setIsLoading,
        setEmail,
        setSenha,
        setModalMsg,
        setMsgModalMsg,
        setDescModalMsg,
        setPerigoModalMsg,
        setTitleButtonModalMsg,
        setFunctionModalMsg,
        setTitleButtonCloseModalMsg,
        setSideBar,
        setIsEdit,
        // Contas Recebimento
        setDataContasRecebimento,
        setContasRecebimento,
        setModalContasRecebimento,
        setIsEditContasRecebimento,
        // Serviços
        setDataServicos,
        setServico,
        setModalServico,
        // Clientes
        setDataClientes,
        setCliente,
        setModalCliente,
        // Faturas
        setDataFaturas,
        setFatura,
        setModalFatura,
    }




    return (
        <AuthContext.Provider
            value={{
                states,
                setters
            }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;
